import React, { useContext } from 'react';
import { HeaderContext } from '../../shared';
import { HighZindexSkipLink, SignedOutHeaderContainer, Spacer } from '../../styles/root';

var HeaderShell = function HeaderShell(_ref) {
  var className = _ref.className,
      children = _ref.children,
      mainContentId = _ref.mainContentId,
      dataTest = _ref['data-test'],
      scrollWithPage = _ref.scrollWithPage;

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighZindexSkipLink, {
    mainContentId: mainContentId,
    showOnFocusOnly: true,
    "data-test": "".concat(dataTestPrefix, "-skip-link")
  }, "Skip to main content"), /*#__PURE__*/React.createElement(SignedOutHeaderContainer, {
    className: className,
    "data-test": dataTest,
    scrollWithPage: scrollWithPage
  }, children), !scrollWithPage && /*#__PURE__*/React.createElement(Spacer, {
    "data-test": "".concat(dataTestPrefix, "-spacer")
  }));
};

HeaderShell.displayName = 'HeaderShell';
export default HeaderShell;